import { TestingStatus } from '../constants/toxicologyStatus';

const isStatusDone = (status?: TestingStatus): boolean => status === TestingStatus.DONE;

export default isStatusDone;
